export enum FeatureFlags {
    DT_SERVICES_FLAG  = 'DT_STORE' ,
}